import { useCallback, useEffect, useState } from 'react';

export type ThemePref = 'light' | 'dark' | 'system';
const KEY = 'app.theme';

function resolve(pref: ThemePref): 'light' | 'dark' {
  if (pref !== 'system') return pref;
  return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}
function apply(pref: ThemePref) {
  const t = resolve(pref);
  document.documentElement.setAttribute('data-theme', t);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', t === 'dark' ? '#121a15' : '#236844');
}
export function readPref(): ThemePref {
  try { const v = localStorage.getItem(KEY); if (v === 'light' || v === 'dark' || v === 'system') return v; } catch {}
  return 'system';
}
/** Апп эхлэхэд нэг удаа: data-theme-ийг html дээр тавьж, system сонголтод OS өөрчлөлтийг дагана. */
export function initTheme() {
  apply(readPref());
  const mq = window.matchMedia?.('(prefers-color-scheme: dark)');
  mq?.addEventListener?.('change', () => { if (readPref() === 'system') apply('system'); });
}
export default function useTheme() {
  const [pref, setPrefState] = useState<ThemePref>(readPref);
  const [resolved, setResolved] = useState<'light' | 'dark'>(() => resolve(readPref()));
  useEffect(() => { apply(pref); setResolved(resolve(pref)); }, [pref]);
  const setPref = useCallback((p: ThemePref) => { try { localStorage.setItem(KEY, p); } catch {} setPrefState(p); }, []);
  const toggle = useCallback(() => setPref(resolve(pref) === 'dark' ? 'light' : 'dark'), [pref, setPref]);
  return { pref, resolved, setPref, toggle };
}
